import { render, staticRenderFns } from "./CubicConecta.vue?vue&type=template&id=45816029&"
import script from "./CubicConecta.vue?vue&type=script&lang=js&"
export * from "./CubicConecta.vue?vue&type=script&lang=js&"
import style0 from "./CubicConecta.vue?vue&type=style&index=0&id=45816029&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports